import {
  AssetStatus,
  enumAssetStatus,
} from '@rematter/frontend-lib-api-client';
import { useTranslations } from '@rematter/modules/transportation/i18n/useTranslations';
import { TextField, WeightField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $assetForm,
  $updateAssetForm,
} from '../../../state/assetForm.localState';

import { SelectAssetType } from '~/shared/components/select-fields/SelectAssetType';
import { SelectEnum } from '~/shared/components/select-fields/SelectEnum';

type AssetFormProps = {
  isEditing?: boolean;
};

export const AssetForm = (_props: AssetFormProps) => {
  const t = useTranslations();
  const form = useAtomValue($assetForm);
  const updateForm = useSetAtom($updateAssetForm);

  const handleFieldChange =
    <K extends keyof typeof form>(field: K) =>
    (value: (typeof form)[K] | undefined) => {
      updateForm({
        [field]: value,
      });
    };

  return (
    <div className="@AssetForm flex flex-col gap-4">
      <TextField
        label={t.assetsView.form.fields.identifier}
        value={form.identifier}
        onChange={handleFieldChange('identifier')}
        isRequired
      />

      <SelectAssetType
        label={t.assetsView.form.fields.type}
        value={form.typeId}
        onChange={handleFieldChange('typeId')}
        isRequired
      />

      <TextField
        label={t.assetsView.form.fields.description}
        value={form.description}
        onChange={handleFieldChange('description')}
      />

      <SelectEnum<AssetStatus>
        enumValue={enumAssetStatus}
        value={form.status}
        onChange={(v) => handleFieldChange('status')(v)}
        label={t.assetsView.form.fields.status}
      />

      <WeightField
        label={t.assetsView.form.fields.tareWeight}
        weightValue={form.tareWeight}
        defaultUnit="Pounds"
        onWeightValueChange={handleFieldChange('tareWeight')}
        isRequired
      />
    </div>
  );
};
